import React from "react";
import { Link, Redirect } from "react-router-dom";
import "./siteSaas.css";

const WHATSAPP_URL = "https://wa.me/5563992281407?text=Ol%C3%A1%2C%20minha%20demonstra%C3%A7%C3%A3o%20da%20Qualinfra%20terminou%20e%20quero%20adquirir%20um%20plano.";

export default function AdquirirPlano() {
  if (process.env.REACT_APP_ENV === "prod") {
    return <Redirect to="/" />;
  }

  return (
    <div className="qs-site qs-public-page">
      <header className="qs-public-header">
        <Link to="/"><img src="/Images/logoSiteSAAS.png" alt="Qualinfra" /></Link>
        <Link to="/app">Voltar ao login</Link>
      </header>
      <main className="qs-expired-main">
        <section className="qs-expired-card">
          <span className="qs-kicker">Período encerrado</span>
          <h1>Sua demonstração de 7 dias terminou.</h1>
          <p>Para continuar usando seu ambiente e manter o acesso aos dados cadastrados, adquira um plano da QualiInfra.</p>
          <div className="qs-unavailable-price">Planos temporariamente não disponíveis para contratação online</div>
          <a className="qs-button qs-button-primary" href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer">
            Falar pelo WhatsApp
          </a>
          <Link className="qs-text-link" to="/">Conhecer a QualiInfra</Link>
        </section>
      </main>
    </div>
  );
}
